/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React, { memo } from 'react';
import styled from 'styled-components';

import { AnimatedLoadingPlaceholder } from '../../../common/animatedLoadingPlaceholder/animatedLoadingPlaceholder';

interface HealthAdviceTopTriggerItemLoadingUIProps {
    showDivider: boolean;
}

export const HealthAdviceTopTriggerItemLoadingUI = memo(({ showDivider }: HealthAdviceTopTriggerItemLoadingUIProps) => {
    return (
        <LoadingWrapper>
            <Container>
                <IconTextLoadingWrapper>
                    <Circle>
                        <AnimatedLoadingPlaceholder width={24} height='24px' radius={16} />
                    </Circle>
                    <TextLoadingContainer>
                        <AnimatedLoadingPlaceholder />
                    </TextLoadingContainer>
                </IconTextLoadingWrapper>
                <ArrowIconLoadingContainer>
                    <Circle>
                        <AnimatedLoadingPlaceholder width={24} height='24px' radius={16} />
                    </Circle>
                </ArrowIconLoadingContainer>
            </Container>
            {showDivider && <Divider />}
        </LoadingWrapper>
    );
});

HealthAdviceTopTriggerItemLoadingUI.displayName = 'HealthAdviceTopTriggerItemLoadingUI';

const LoadingWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    height: 48px;
    background: #F9F9F9;
    padding: 0px 8px;
`;

const Container = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    height: calc(100% - 1px);
`;

const IconTextLoadingWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 112px;
    height: 100%;
`;

const Circle = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 24px;
    height: 24px;
`;

const TextLoadingContainer = styled.div`
    display: flex;
    flex-direction: row;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    height: 16px;
    width: 80px;
`;

const ArrowIconLoadingContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    width: calc(100% - 112px);
    height: 24px;
`;

const Divider = styled.span`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0px 8px;
    width: 100%;
    height: 1px;
    background: #EEEEEE;
`;
